module.exports = __webpack_public_path__ + "static/the-complete-novels-of-jane-austen-b7d04f74f09fd1754ff38655f891b388.jpg";